const homolog = "https://queroquitar-hml.2be.tools";

const prod = "https://queroquitar.2be.tools/";

const baseUrls = { homolog, prod };
const href = window.location.href;
// const isDev = href.includes("localhost") ? true : false;
const isHml = href.includes("-hml") ? "homolog" : null;

const environment = isHml || "prod";
const getBaseUrl = (env = environment) => baseUrls[env];

export default getBaseUrl();
